import React from 'react';
import { connect } from 'react-redux';

import {
    DoohPublishersSummary,
    TargetDoohPublishers,
} from 'forms/ad-form/modules/target-dooh-publishers';

import BaseColumnForm from '../base-column-form';
import shallowCompare from 'utils/shallow-compare';

class DoohPublishersSummaryBulkEditUnconnected extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate =
            !shallowCompare(this.props, nextProps) || !shallowCompare(this.state, nextState);
        return shouldUpdate;
    }

    render() {
        const { ad, doohPublishers } = this.props;
        console.log({ props: this.props });
        return (
            <div>
                <DoohPublishersSummary
                    target_dooh_publishers={ad.target_dooh_publishers}
                    target_dooh_publishers_exclude={ad.target_dooh_publishers_exclude}
                    doohPublishers={doohPublishers}
                />
            </div>
        );
    }
}

export const DoohPublishersSummaryBulkEdit = connect(state => ({
    doohPublishers: state.resources.doohPublishers,
}))(DoohPublishersSummaryBulkEditUnconnected);

class DoohPublishersFormBulkEditUnconnected extends React.Component {
    render() {
        const { ad, ads, campaign, onSave, doohPublishers } = this.props;

        const fields = ['target_dooh_publishers', 'target_dooh_publishers_exclude'];

        return (
            <BaseColumnForm
                ad={ad}
                ads={ads}
                campaign={campaign}
                headline="Include or exclude DOOH Publishers"
                fields={fields}
                shouldRefreshPredictionsOnSave={true}
                onSave={onSave}
                onCancel={onSave}
                columnName="DOOH Publishers"
            >
                {(updateDraft, shouldShowErrors, errors, draft) => {
                    return (
                        <TargetDoohPublishers
                            onFieldChange={field => values => updateDraft({ [field]: values })}
                            doohPublishers={doohPublishers}
                            target_dooh_publishers={draft.target_dooh_publishers}
                            target_dooh_publishers_exclude={draft.target_dooh_publishers_exclude}
                        />
                    );
                }}
            </BaseColumnForm>
        );
    }
}

export const DoohPublishersFormBulkEdit = connect(state => ({
    doohPublishers: state.resources.doohPublishers,
}))(DoohPublishersFormBulkEditUnconnected);
